export interface IAutoplayView {
    setAutoplayFieldText(text: string): void;

    hideAutoplayUI(): void;

    showAutoplayUI(): void;

    stopAutoplayButtonClickAction(): void;
}
